import React from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { SchoolLocationMap } from '../SchoolLocationMap'
import { SchoolDetailsSectionSubTitle } from '../School/SchoolDetailsSectionTitle'
import { Text } from '../../components/Text'
import { STYLES } from '../../static/style'
import { ScreenSizeHelper } from '../../helpers/ScreenSizeHelper'
import { GoogleDirectionsLink } from '../../components/Link/GoogleDirectionsLink'

const StyledSchoolLocation = styled.div`
  width: 100%;
`

const MobileSchoolLocationMap = styled(SchoolLocationMap)`
  width: 100%;
`

const AddressContainer = styled.div`
  margin-bottom: ${STYLES.GUTTER};
`

const AddressText = styled(Text)`
  color: ${STYLES.COLOR_PALE_SKY_GRAY};
  margin-right: 0.5rem;
`

interface ISchoolLocationProps {
  location: any
}

const SchoolLocation: React.FC<ISchoolLocationProps> = ({ location }) => {
  const screenSize = useSelector(({ screenSize: sz }) => sz.size)
  // do not show this component in desktop screen size
  if (
    ScreenSizeHelper.getScreenSizeValueFromObject(screenSize, {
      default: false,
      MD: true,
    })
  ) {
    return null
  }
  const {
    address,
    coords: [lng, lat],
  } = location
  return (
    <StyledSchoolLocation>
      <SchoolDetailsSectionSubTitle>Location</SchoolDetailsSectionSubTitle>
      {address && (
        <AddressContainer>
          <AddressText>{address}</AddressText>
          <GoogleDirectionsLink coords={{ lat, lng }} />
        </AddressContainer>
      )}
      <MobileSchoolLocationMap isShowOverlay={false} location={location} />
    </StyledSchoolLocation>
  )
}

export { SchoolLocation }
